module.exports = __webpack_public_path__ + "static/media/optionq-banner-mobile.b63ab141.png";